import { useContext } from "react";
import type { ThreeDotsOverlayContextProps } from "@/shared/components/generic/loading/ThreeDotsOverlayContext.ts";
import { ThreeDotsOverlayContext } from "@/shared/components/generic/loading/ThreeDotsOverlayContext.ts";

export const useThreeDotsOverlay = (): ThreeDotsOverlayContextProps => {
  const context = useContext(ThreeDotsOverlayContext);
  if (!context) {
    throw new Error(
      "useThreeDotsOverlay must be used within ThreeDotsOverlayProvider",
    );
  }
  return context;
};
